import { render, staticRenderFns } from "./HomeCategoriesMobile.vue?vue&type=template&id=eda57448&scoped=true"
import script from "./HomeCategoriesMobile.vue?vue&type=script&lang=ts"
export * from "./HomeCategoriesMobile.vue?vue&type=script&lang=ts"
import style0 from "./HomeCategoriesMobile.vue?vue&type=style&index=0&id=eda57448&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda57448",
  null
  
)

export default component.exports